import React from "react";
import { Row, Col } from "react-bootstrap";

function ImageGrid() {
  const placeholderImages = Array(10).fill("https://placehold.co/150");

  return (
    <section className="container px-5">
      <Row className="g-4 p-5">
        {placeholderImages.map((imgUrl, index) => (
          <Col
            key={index}
            xs={12}
            sm={6}
            md={4}
            lg={3}
            className="d-flex align-items-center justify-content-center p-0"
          >
            <img
              src={imgUrl}
              alt={`Placeholder ${index + 1}`}
              className="img-fluid"
            />
          </Col>
        ))}
      </Row>
    </section>
  );
}

export default ImageGrid;
